export default [
  {
    path: '/salary',
    name: 'salary',
    component: () => import('@/views/salary/Salary.vue'),
    meta: {
      title: 'Salary ',
      requiresAuth: true,
      action: 'browes',
      resource: 'Salary',
      pageTitle: 'Salary',
      breadcrumb: [
        {
          text: 'Salary',
        },
        {
          text: 'List',
          active: true,
        },
      ],
    },
  },
]
